import React, { Component } from "react";
import styled from "styled-components";
import { sanitizeHtmlText } from "js/core/utilities/htmlTextHelpers";

const notesHeadingStyles = `
  h1 {
    font-size: 1.5em;
    font-weight: bolder;
    margin: 0;
  }

  h2 {
    font-size: 1.2em;
    font-weight: bolder;
    margin: 0;
  }
`;

const MobileNotesContainer = styled.div`
  padding: 70px;
  color: #eee;
  font-size: 3em;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  flex-shrink: 10;
  margin-bottom: 2em;
  ${notesHeadingStyles}
`;

const NotesContainer = styled.div`
  padding: 20px;
  color: #eee;
  font-size: 1em;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  flex-shrink: 1;
  ${notesHeadingStyles}
`;

export class SlideNotes extends Component {
    render() {
        const { notes, isMobileOrTablet } = this.props;

        const sanitizedNotes = sanitizeHtmlText(notes);
        if (isMobileOrTablet) {
            return (
                <MobileNotesContainer dangerouslySetInnerHTML={{ __html: sanitizedNotes }} />
            );
        } else {
            return (
                <NotesContainer dangerouslySetInnerHTML={{ __html: sanitizedNotes }} />
            );
        }
    }
}

